// extracted by mini-css-extract-plugin
export var icon = "_bz-3";
export var subtitle = "_bz-2";
export var title = "_bz-1";
export var value = "_bz-0";